module.exports = __webpack_public_path__ + "img/courseware.7ae8594c.svg";